require('intersection-observer');
var lozad = require('lozad');

(function ($) {

  /* FASASSO 2017 - JS */

  var $body,
    $header,
    $bigH1,
    $smlH1,
    $somTrig,
    $sommaire,
    $gloTrig,
    $glossaire,
    $alphaGloss,
    $alphaGlossLettre,
    $defGloss,
    $keyTrig,
    $keywords,
    $alphaKey,
    $alphaKeyLettre,
    $defKey,
    $closeMoreBtn,
    topPos = 0,
    scrollwidth,
    preloaderTxt = '<div class="preloader-gh"><div class="loader"><svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div></div>';

  var FASASSO = window.FASASSO || {

    checkGloss: function () {
      // console.log('checkGloss');
      topPos = $alphaGloss.position().top + $alphaGloss.outerHeight(true);
      $defGloss.css('top', topPos);
    },
    checkKey: function () {
      // console.log('checkKey');
      topPos = $alphaKey.position().top + $alphaKey.outerHeight(true);
      $defKey.css('top', topPos);
    },

    alphaFocus: function (cible) {
      // console.log('alphaFocus');
      $('.focus').removeClass('focus');
      var $clickLettre = $(cible.target);
      $clickLettre.addClass('focus');
    },

    removeSpaces: function () {
      $('p,li').contents().filter(function () {
        return this.nodeType == 3; // Text node
      }).each(function () {
        //        console.log(this);
        this.data = this.data.replace(/ !/g, '\u00A0!');
        this.data = this.data.replace(/ :/g, '\u00A0:');
        this.data = this.data.replace(/ \?/g, '\u00A0?');
        this.data = this.data.replace(/ \u20AC/g, '\u00A0€');
      });
    },

    openMore: function (fenetre) {
      // console.log('openMore : ' + fenetre);
      fenetre.show();
      if (fenetre == $glossaire) {
        FASASSO.checkGloss();
        $('.more.gloss .close').show();
      } else if (fenetre == $keywords) {
        FASASSO.checkKey();
        $('.more.key .close').show();
      }
      fenetre.hide();
      $body.addClass('more-open');
      // $body.css("padding-right", scrollwidth);
      fenetre.fadeIn();
    },

    closeMore: function () {
      var $more;
      if ($('.sommaire-niveau-1:visible').length && !$('.home').length) {
        $more = $('.sommaire-niveau-1:visible');
      } else {
        $more = $('.more:not(.sommaire-niveau-0):visible');
        $closeMoreBtn.hide();
      }


      $body.removeClass('more-open');
      $body.css("padding-right", '0');
      $more.animate({
        'opacity': 0
      }, 400, function () {
        $more.find('.def').scrollTop(0);
        $more.find('.focus').removeClass('focus');
        $more.hide()
        $more.css('opacity', 1);
      });

    },

    showDisclaimerOrNot: function () {
      if (window.sessionStorage && sessionStorage.getItem('disclaimerseen')) {
        // They've been here before.
        // console.log('visited yes');
      } else {
        // console.log('visited no');
        // set a new cookie
        window.sessionStorage && sessionStorage.setItem('disclaimerseen', true);
        var $disclaimer = $('#disclaimer');
        var self = this;
        this.openMore($disclaimer);
        $disclaimer.on('click', function (e) {
          self.closeMore();
        });
      }
    },

    init: function () {
      // console.log('init');

      $body = $('body');
      $header = $('header');
      $bigH1 = $('h1');
      $smlH1 = $('.h1');
      $somTrig = $('.somm-trigger');
      $planTrig = $('.plan-trigger');
      $sommaire = $('.somm');
      $plan = $('.plan');
      $gloTrig = $('.glo-trigger');
      $glossaire = $('.gloss');
      $alphaGloss = $('.gloss .alphabet');
      $alphaGlossLettre = $('.gloss .alphabet li');
      $defGloss = $('.gloss .def');
      $keyTrig = $('.key-trigger');
      $keywords = $('.key');
      $alphaKey = $('.key .alphabet');
      $alphaKeyLettre = $('.key .alphabet li');
      $defKey = $('.key .def');
      $closeMoreBtn = $('.close');

      scrollwidth = (window.innerWidth - $(window).width());

      // Initialize lazy load
      lozad('.lozad', {
        load: function (el) {
          el.src = el.dataset.src;
          el.onload = function () {
            el.classList.add('fade')
          }
        }
      }).observe()

      //Detect mobile
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // console.log('READY MOBILE');
        $body.addClass("isMobile");
      } else {
        // console.log('READY DESKTOP');
        $body.addClass("isDesktop");
      }

      //PRELOADER GH ajouté
      $body.append(preloaderTxt);

      //Préparation sticky header
      $header.data('size', 'big');

      //Masquage burger si homepage
      if ($('.home').length) {
        $somTrig.hide();
      };

      //#region SOMMAIRE
      //Open le sommaire
      $somTrig.on('click', function () {
        FASASSO.openMore($sommaire);
        $sommaire.find('.close').show();
      });

      //Fonctionnement du sommaire
      $('.sommaire-niveau-0 > div >.table > a.chapitre').on('click', function (e) {
        e.preventDefault();
        $(e.target).closest('.table').find('.sommaire-niveau-1').show();
        $sommaire.find('.close').show();
      });
      $('.sommaire-niveau-1 a').on('click', function (e) {
        FASASSO.closeMore();
        $sommaire.hide();
      });
      //#endregion SOMMAIRE

      //#region PLAN
      //Open le plan
      $planTrig.on('click', function () {
        FASASSO.openMore($plan);
        $plan.find('.close').show();
      });
      //#endregion PLAN

      //Open le glossaire
      $gloTrig.on('click', function () {
        FASASSO.openMore($glossaire);
        $glossaire.find('.close').show();
      });

      //Open keywords
      $keyTrig.on('click', function () {
        FASASSO.openMore($keywords);
        $keywords.find('.close').show();
      });

      //Close popin
      $closeMoreBtn.on('click', function () {
        FASASSO.closeMore();
      });

      //Fonctionnement glossaire
      $alphaGlossLettre.on('click', function (e) {
        var laLettre = $(e.target).data('letter');
        FASASSO.alphaFocus(e);
        $defGloss.scrollTo($('.gloss ul.l-' + laLettre), 250, 'easeInOutExpo');
      });

      //Fonctionnement keywords
      $alphaKeyLettre.on('click', function (e) {
        var laLettre = $(e.target).data('letter');
        FASASSO.alphaFocus(e);
        $defKey.scrollTo($('.key ul.l-' + laLettre), 250, 'easeInOutExpo');
      });

      this.showDisclaimerOrNot();

      // rewrite footer notes
      $('a[id]').each(function (i, el) {
        var $el = $(el);
        var $article = $el.closest('article');
        var $h3 = $article.children('h3[id]');

        $el.parent().addClass('anchor');

        if ($h3.length) {
          var $as = $article.find('a[href="#' + this.id + '"]');
          var nid = this.id + '-' + $h3[0].id;
          this.id = nid;
          $as.each(function (i, el) {
            el.href = '#' + nid;
            $(el).on('click', function (e) {
              e && e.preventDefault();
              var $this = $(this);
              var $target = $($this.attr('href'));
              $('html,body').scrollTo($target.offset().top);
              window.history.pushState({}, document.title, $this.attr('href'));
            });
          });
        }
      });

    }
  };

  //Sticky header
  $(window).on('scroll', function () {

    if (!$header) return true;

    if ($(document).scrollTop() > 0) {
      //Page scrollée
      if ($header.data('size') == 'big') {
        $header.data('size', 'small');
        $body.addClass('scrolled');
        $bigH1.hide();
        $smlH1.fadeIn('800');
        $header.stop().animate({
          height: '40px'
        }, 40);
      }
    } else {
      //Page non scrollée
      if ($header.data('size') == 'small') {
        $header.data('size', 'big');
        $body.removeClass('scrolled');
        $smlH1.hide();
        $bigH1.fadeIn('800');
        $header.stop().animate({
          height: '130px'
        }, 40);
      }
    }
  });

  $(window).on('load', function () {
    //PRELOADER GH masqué puis supprimé
    // console.log('loaded', $body);
    $body.addClass('loaded');
    $('.preloader-gh').remove();
    FASASSO.removeSpaces();
    if (window.location.hash != '') {
      var $target = $(window.location.hash);
      // console.log($target, $target.position());
      $('html,body').scrollTo($target.offset().top);
    }
  });

  //Glossaire position
  $(window).on('resize', function () {
    FASASSO.checkGloss();
  });

  //Init
  $(document).ready(function () {
    FASASSO.init();
  })

})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 5
// module chunks = 0